// extracted by mini-css-extract-plugin
export default {"first":"Topsec_first__Cxk4l","img":"Topsec_img__+sbQv","h1":"Topsec_h1__aKgsR","h3":"Topsec_h3__ZfWzx","btn":"Topsec_btn__G7Uv4","position":"Topsec_position__9IXvp"};